import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import {
    ColonDirective,
    RightAlignDirective,
    NoWhitespacesDirective,
    InputCheckDirective,
    TrimDirective,
    OnlyNumbersDirective
} from "./directives";
import {
    RangeNumberValidatorDirective,
    RangeDateValidatorDirective,
    NotEmptyValidatorDirective,
    GreaterThanValidatorDirective,
    EqualValidatorDirective,
    NoSideWhitespacesValidatorDirective,
    LessThanValidatorDirective,
    EmailMaxLengthValidatorDirective
} from "./modules/validation";
import { JoinPipe, NumOperationsPipe } from "./pipes";
import { RangePipe } from "@bbwt/pipes/range.pipe";
import { MapPipe } from "./pipes/map.pipe";

@NgModule({
    declarations: [
        // Directives
        ColonDirective,
        RightAlignDirective,
        NoWhitespacesDirective,
        OnlyNumbersDirective,
        InputCheckDirective,
        TrimDirective,
        // Validation directives
        RangeNumberValidatorDirective,
        RangeDateValidatorDirective,
        NotEmptyValidatorDirective,
        GreaterThanValidatorDirective,
        EqualValidatorDirective,
        NoSideWhitespacesValidatorDirective,
        LessThanValidatorDirective,
        EmailMaxLengthValidatorDirective,
        // Pipes
        JoinPipe,
        RangePipe,
        NumOperationsPipe,
        MapPipe
    ],
    imports: [CommonModule],
    exports: [
        // Directives
        ColonDirective,
        RightAlignDirective,
        NoWhitespacesDirective,
        OnlyNumbersDirective,
        InputCheckDirective,
        // Validation directives
        RangeNumberValidatorDirective,
        RangeDateValidatorDirective,
        NotEmptyValidatorDirective,
        GreaterThanValidatorDirective,
        EqualValidatorDirective,
        NoSideWhitespacesValidatorDirective,
        LessThanValidatorDirective,
        EmailMaxLengthValidatorDirective,
        // Pipes
        JoinPipe,
        RangePipe,
        NumOperationsPipe,
        MapPipe,
        TrimDirective
    ]
})
export class BbwtSharedModule {
}
